import { Route, Redirect} from "react-router-dom";
import secureLocalStorage from "react-secure-storage";


const userToken = secureLocalStorage.getItem("token");
// const token:any =  jwt_decode(userToken);
// const expiresIn = token && token?.expiresIn;

export const AuthRouteRedirect = ({component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                // if(expiresIn > Math.floor(Date.now() / 1000) && userToken){
                if(!userToken){
                    return <Component {...props} />;
                } else {
                    if(props.location?.pathname){
                        secureLocalStorage.setItem("intended",props.location?.pathname);
                    }
                    return (
                        <Redirect
                            to={{
                                pathname: "/admin/dashboard",
                            }}
                        />
                    );
                }
            }}
        />
    );
};


export default AuthRouteRedirect;
